export const PROTOCOL_REGEX = /^.*:\/\//;

export const ORDER_NUMBER_PATTERN = new RegExp('^([A-Z0-9])\\w{3}-([A-Z0-9])\\w{3}$');
